var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlinedPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24pt",
    height: "24pt",
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(42,172,226)",
      fillRule: "nonzero"
    },
    d: "M 1.761719 14.375 L 1.664062 14.3125 C 3.429688 11.792969 6.363281 10.289062 9.5 10.289062 C 12.636719 10.289062 15.570312 11.792969 17.335938 14.3125 L 17.238281 14.375 C 15.496094 11.890625 12.597656 10.402344 9.5 10.402344 C 6.402344 10.402344 3.507812 11.890625 1.761719 14.375 Z M 1.761719 14.375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(42,172,226)",
      fillRule: "nonzero"
    },
    d: "M 9.5 18.398438 C 4.265625 18.398438 0.0234375 14.28125 0.0234375 9.199219 C 0.0234375 4.117188 4.265625 0 9.5 0 C 14.734375 0 18.976562 4.117188 18.976562 9.199219 C 18.96875 14.277344 14.730469 18.394531 9.5 18.398438 Z M 9.5 0.113281 C 4.332031 0.113281 0.140625 4.183594 0.140625 9.199219 C 0.140625 14.21875 4.332031 18.285156 9.5 18.285156 C 14.667969 18.285156 18.859375 14.21875 18.859375 9.199219 C 18.855469 4.183594 14.667969 0.121094 9.5 0.113281 Z M 9.5 0.113281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(42,172,226)",
      fillRule: "nonzero"
    },
    d: "M 9.5 9.257812 C 7.191406 9.257812 5.320312 7.441406 5.320312 5.199219 C 5.320312 2.960938 7.191406 1.144531 9.5 1.144531 C 11.808594 1.144531 13.679688 2.960938 13.679688 5.199219 C 13.675781 7.441406 11.808594 9.253906 9.5 9.257812 Z M 9.5 1.257812 C 7.257812 1.257812 5.4375 3.023438 5.4375 5.199219 C 5.4375 7.378906 7.257812 9.144531 9.5 9.144531 C 11.742188 9.144531 13.5625 7.378906 13.5625 5.199219 C 13.558594 3.023438 11.742188 1.257812 9.5 1.257812 Z M 9.5 1.257812 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedPersonIcon);
export default __webpack_public_path__ + "static/media/outlinedPersonIcon.31a6ffcb.svg";
export { ForwardRef as ReactComponent };